import { InputJson } from "nq-component";
import BaseFormPage from "../../../../base/BaseFormPage";
import NoticesFormPresenter from "./NoticesFormPresenter";
import {
  findObjectUseCase,
  getObjectUseCase,
  upsertUseCase,
} from "../../../../usecases/object";
import withRouter from "../../../../withRouter";
import MultipleSelectHierarchy from "../../../../components/common/MultipleSelectHierarchy";
import { createNotification } from "../../../../createNotification";
import FormFactory from "../../../../components/FormFactory";

class NoticeFormPage extends BaseFormPage {
  constructor(props) {
    super(props);
    this.state = {
      object: {},
      // hierarchy: {},
      sendToAll: false,
      advanced: false,
      description: "",
      title: "",
    };
    this.presenter = new NoticesFormPresenter(
      this,
      getObjectUseCase(),
      upsertUseCase(),
      findObjectUseCase(),
    );
  }

  getCollectionName() {
    return "notices";
  }

  async componentDidMount() {
    this.presenter.componentDidMount();
  }

  // async componentDidUpdate(prevProps, prevState) {
  //   const { object } = this.state;
  //   if (prevState.object !== this.state.object) {
  //     const employeeName = `${object?.employee?.Firstname || ""} ${
  //       object?.employee?.Middlename || ""
  //     } ${object?.employee?.surname || ""}`;
  //     this.setState({
  //       selectedemployee: { name: employeeName, id: object?.employee?.id },
  //       description: object.description,
  //       selectedFiles: object.selectedFiles,
  //       title: object.title,
  //       selectedtemplates: object.template,
  //       sendToAll: object.sendToAll,
  //       objectID: object.id,
  //     });
  //     this.handleHierarchyChange(object);
  //   }
  // }

  onClickAdvance() {
    this.setState({ advanced: !this.state.advanced });
  }

  onChangeObject(object) {
    this.presenter.onChangeObject(object);
  }

  fields = [
    "selectedregions",
    "selectedoffices",
    "selecteddivisions",
    "selectedsections",
    "selectedunits",
    "selectedplantilla",
  ];

  async onChangeOption(field, value) {
    if (field === "sendToAll") {
      this.setState({ sendToAll: !this.state.sendToAll });
    } else if (field === "selectedtemplates") {
      this.setState({
        selectedtemplates: value.name,
        description: value.description,
      });
    } else {
      this.setState({ [field]: value });
    }
  }

  async handleSubmit() {
    const data = {
      ...this.state.object,
      ...this.state.hierarchy,
    };
    try {
      await upsertUseCase().execute("notices", data);
      const NOTIFICATION_MESSAGE =
        "New notice have been added to your Dashboard Notice Board!";
      let NOTIFICATION_RECEIVER = [
        "role:Supervisor",
        "role:Super Admin",
        "role:user",
      ];

      if (data.employee) {
        NOTIFICATION_RECEIVER = [data.employee.id];
      }
      const NOTIFICATION_REDIRECT = "dashboard";

      createNotification(
        NOTIFICATION_MESSAGE,
        NOTIFICATION_RECEIVER,
        NOTIFICATION_REDIRECT,
      );

      this.presenter.showSuccess("SUCCESS:");
    } catch (e) {
      console.error(e);
    }
  }

  async handleHierarchyChange(hierarchy) {
    const entry = Object.fromEntries(
      Object.entries(hierarchy).map(([key, value]) => [
        key.replace(/^selected/, "").replace(/^./, (c) => c.toLowerCase()), // remove 'selected' and lowercase first letter
        value,
      ]),
    );

    this.setState({ hierarchy: entry });
  }

  async onChange(value, field) {
    // this.presenter.onChange(value, field);
    if (field === "template") {
      const template = await this.presenter.fetchTemplates(value);
      if (template.length > 0) {
        this.setState((prevState) => ({
          object: {
            ...prevState.object,
            description: template[0]?.description,
          },
        }));
      }
    }

    this.setState((prevState) => ({
      object: { ...prevState.object, [field]: value },
    }));
  }
  render() {
    const { object } = this.state;
    const advanced = this.state.advanced;
    // const isViewData = Object.keys(this.props.object)?.length > 0;
    const schema = this.getSchema(this.getCollectionName());
    const label = this.getObjectId() === undefined ? "Add New" : "Update ";
    if (!schema) return <h1>no schema</h1>;
    const path = this.props.location.pathname;
    const isViewMode = path.startsWith("/view/");
    const excludeFields = [
      "created",
      "updated",
      "regions",
      "offices",
      "divisions",
      "sections",
      "units",
      "plantilla",
      // "description",
      "sendToAll",
    ];
    const excluded = Object.keys(schema.fields).filter((key) =>
      excludeFields.includes(key),
    );

    return (
      <>
        <div className="overflow-auto">
          <div className="h-100">
            <div className="p-3 p-lg-4">
              <h1 className="fw-bold text-capitalize">
                {(schema.label || this.getCollectionName()) + " Details"}
              </h1>
              <div className="mt-3 bg-white shadow rounded p-3 px-lg-5 py-lg-4">
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    this.handleSubmit();
                  }}
                >
                  <div className="row g-3">
                    {advanced ? (
                      <InputJson
                        defaultValue={object}
                        onChange={this.onChangeObject.bind(this)}
                        rows="15"
                      />
                    ) : (
                      <>
                        <div className="p-0">
                          <FormFactory
                            className="p-2 col-lg-12"
                            schema={schema}
                            object={object}
                            disabled={isViewMode}
                            onChange={this.onChange.bind(this)}
                            excludeFields={Object.keys(schema.fields).filter(
                              (key) => !["sendToAll"].includes(key),
                            )}
                          />

                          <div className="row mt-2">
                            <MultipleSelectHierarchy
                              className="col-lg-4"
                              object={this.state.object}
                              required={true}
                              handleObjectChange={this.handleHierarchyChange.bind(
                                this,
                              )}
                              disabled={
                                this.state.object.sendToAll || isViewMode
                              }
                            />

                            <FormFactory
                              className="p-2 col-lg-12"
                              schema={schema}
                              object={object}
                              disabled={isViewMode}
                              onChange={this.onChange.bind(this)}
                              excludeFields={excluded}
                            />
                            {/* <div className="col-lg-12 mt-4">
                              <RichText
                                onContentChange={(value) =>
                                  this.onChange(value, "description")
                                }
                                disabled={isViewMode}
                                content={this.state.object.description}
                              />
                            </div> */}
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                  <div className="mt-4">
                    {!isViewMode && (
                      <button
                        type="submit"
                        className="btn btn-primary fs-sm me-3"
                      >
                        <i className="bi bi-file-earmark-check me-2"></i>
                        {label}
                      </button>
                    )}
                    <button
                      type="button"
                      className="btn btn-light fs-sm"
                      onClick={this.onClickBack.bind(this)}
                    >
                      GO BACK
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(NoticeFormPage);
